<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { defineProps, defineExpose, reactive, ref, watch, inject } from 'vue';
    import axios from 'axios';
    import { formatAmount } from '@/utils';

    defineExpose({ doGetWalletDetailsInfos });

    const props = defineProps<{
        startupInfos: any
    }>();
    const collectivite = ref(null as any);
    const loading = ref(false);
    const errorMessage = ref('');
    const statsInfos = reactive({
        montant_decaissement: 0,
        total_decaissement: 0,
        montant_prelevement: 0,
        solde: 0
    });

    watch(() => props.startupInfos, (newVal: any) => {
        const isFirstChanged = !collectivite.value;
        collectivite.value = newVal.collectivite;
        if (collectivite.value && isFirstChanged) {
            doGetWalletDetailsInfos();
        }
    }, { immediate: true });

    async function doGetWalletDetailsInfos() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const httpResponse = await axios.get(`/backoffice/finance/prelevements/get_wallet_infos/${collectivite.value.id}`);
            Object.assign(collectivite.value, httpResponse.data);
        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }
</script>
<template>
    <div class="s20 widget px-6 pt-8 pb-2">
        <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
            <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                Wallet / Décaissement
            </span>
        </div>
        <div class="s10 mt--5-5 flex-right">
            <!-- <button class="btn lg py-3 white2 active">
                <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                <span>Décaissements</span>
            </button> -->
        </div>

        <div class="s20 gap-6 px-5 pb-8 collapse-content active">
            <div class="clear-both h-10"></div>
            <div class="flex items-center gap-6">
                <div class="s7">
                    <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                        <div class="circle-medium bg-color-black"></div>
                        Solde
                    </h5>
                    <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">{{ formatAmount(collectivite.solde) }} F</h1>
                    <h5 class="secondary-font font-semibold text-grey-700 mb-4">{{ collectivite.solde_percent }}%</h5>
                    <!--Barre de progression - Component-->
                    <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                        <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-black" :style="{'width': collectivite.solde_percent + '%'}">
                            {{ collectivite.solde_percent }}%
                        </div>
                    </div>
                    <!--End Barre de progression-->
                </div>
                <div class="s7">
                    <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                        <div class="circle-medium bg-color-1000"></div>
                        Montant Décaissé
                    </h5>
                    <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">{{ formatAmount(collectivite.total_montant_decaissements) }} F</h1>
                    <h5 class="secondary-font font-semibold text-grey-700 mb-4">{{ collectivite.decaissements_percent }}%</h5>
                    <!--Barre de progression - Component-->
                    <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                        <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white" :style="{'width': collectivite.decaissements_percent + '%'}">
                            {{ collectivite.decaissements_percent }}%
                        </div>
                    </div>
                    <!--End Barre de progression-->
                </div>
                <div class="s6">
                    <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                        <div class="circle-medium bg-green-light"></div>
                        Dernier décaissement
                    </h5>
                    <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">{{ formatAmount(collectivite.last_montant_decaissement) }} F</h1>
                    <h5 class="secondary-font font-semibold text-grey-700 mb-4">{{ collectivite.last_decaissement_percent }}%</h5>
                    <!--Barre de progression - Component-->
                    <div class="h-40 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                        <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light" :style="{'width': collectivite.last_decaissement_percent + '%'}">
                            {{ collectivite.last_decaissement_percent }}%
                        </div>
                    </div>
                    <!--End Barre de progression-->
                </div>
            </div>
        </div>

    </div>
</template>